import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import DynamicBreadcrumbs from "../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { Container, MasterContainer } from "./BreadcrumbContainer.styled";
import { useContacts } from "../../context/ContactsContext";
import { useParams } from "react-router-dom";

const BreadcrumbContainer = () => {
  const location = useLocation();
  const { pathname } = location;
  const { contactId } = useParams();
  const { contactDetails } = useContacts();
  const contactNameFromState = location.state?.contactName;

  const resolvedContactName = useMemo(() => {
    return contactNameFromState || contactDetails?.legalName || contactId;
  }, [contactNameFromState, contactDetails?.legalName, contactId]);

  const items = [
    { label: "Contacts", href: "/v2/ucp" },
    {
      label: resolvedContactName,
      href: pathname,
    },
  ];

  return (
    <MasterContainer>
      <Container>
        <DynamicBreadcrumbs items={items} currentPath={pathname} />
      </Container>
    </MasterContainer>
  );
};

export default BreadcrumbContainer;
